var __TEMP__ = require('./_baseFor.js');var baseFor = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./keys.js');var keys = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = baseForOwn;
